// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import AdvancedAnalyticsSvg from '@rsuite/icon-font/lib/application/AdvancedAnalytics';
var AdvancedAnalytics = createSvgIcon({
  as: AdvancedAnalyticsSvg,
  ariaLabel: 'advanced analytics',
  category: 'application',
  displayName: 'AdvancedAnalytics'
});
export default AdvancedAnalytics;